const isLocal = window.devmode;
const env = window.env || "prod";

/* eslint-env browser */
/* eslint-disable */
if (!Object.entries) {
  Object.entries = obj => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}

const Get = (obj, key) => {
  return key.split(".").reduce(function(o, x) {
    return typeof o == "undefined" || o === null ? o : o[x];
  }, obj);
};

const getUrlParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
/* eslint-enable */

const userContextDesktop = Get(window, "bwin.config.promoConfig");
const userContextMobile = Get(window, "clientConfig.promoConfig");
const userInfoDesktop = Get(window, "bwin.config.userInfo");
const userInfoMobile = Get(window, "clientConfig");

const userContext = () => {
  if (userContextDesktop) return userContextDesktop;
  if (userContextMobile) return userContextMobile;
  return {};
};

const userInfoContext = () => {
  if (userInfoDesktop) return userInfoDesktop;
  if (userInfoMobile) {
    return {
      // Sso: userInfoMobile.m2ClaimsConfig["http://api.bwin.com/v3/user/ssotoken"]
      Sso: userInfoMobile.vnClaims["http://api.bwin.com/v3/user/ssotoken"]
    };
  }
  return {};
};

const userVars = Object.freeze({
  ...userContext(),
  ...userInfoContext(),
  isNew: userContext.isKnown === false
});

/* eslint-disable no-underscore-dangle */
const sitecoreVars = Object.freeze({
  lang: window.promo.lang,
  portal: window.promo.portal,
  culture:
    window.promo.culture === undefined
      ? window.promo.lang
      : window.promo.culture,
  bonusID: window.promo.bonus_promotion_dbid,
  isMobile: window.promo.isMobile === "True",
  targetgroup_id: window.promo.targetgroup_id,
  tcsFolder: window.promo.tcsFolder,
  currency: window.promo.currency,
  promoContent: window.promoContent,
  messages: window.promo.messages,
  apiUrl: window.promo.api,
  brandId: window.promo.brandId,
  channel: window.promo.channel,
  userSSO: window.promo.userSSO
});
/* eslint-enable no-underscore-dangle */

// const localhost = "//3ad3eaca.ngrok.io";
const localhost = "//localhost:8080";

const envConfig = Object.freeze({
  dev: {
    host: localhost,
    api: "//api-mk.itsfogo.com/api/v1",
    apiv2: "//api-mk.itsfogo.com/api/v2/CRM.svc"
  },
  prod: {
    host: isLocal ? localhost : "//mkp.itsfogo.com/sites/pc/promo/calendar-sb",
    api: "//api-mk.itsfogo.com/api/v1",
    apiv2: "//api-mk.itsfogo.com/api/v2/CRM.svc"
  },
  beta: {
    host: isLocal ? localhost : "//mkp.itsfogo.com/sites/pc/promo/calendar-sb",
    api: "//beta-api-mk.itsfogo.com/api/v1",
    apiv2: "//beta-api-mk.itsfogo.com/api/v2/CRM.svc"
  }
});

/* eslint-disable no-prototype-builtins */
const GLOBALS = Object.freeze({
  user: userVars,
  sitecore: sitecoreVars,
  config: envConfig.hasOwnProperty(env) ? envConfig[env] : envConfig.prod,
  GET: Get,
  getUrlParameterByName: getUrlParameterByName,
  local: "localhost"
});
/* eslint-enable */

(Element.prototype.appendAfter = function(element) {
  element.parentNode.insertBefore(this, element.nextSibling);
}),
  false;

export default GLOBALS;



// WEBPACK FOOTER //
// ./src/helpers/globals.js